// notificationApi.js

import api from "./api"; // adjust path to your api instance

/**
 * Fetch all notifications for the current user
 */
export async function fetchNotifications() {
  try {
    const response = await api.get("event-notifications/");
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications: ", error);
    return [];
  }
}

/**
 * Mark a notification as seen by its ID
 */
export async function markAllNotificationsSeen() {
  try {
    const res = await api.post("event-notifications/mark-all-seen/");
    return res.data;
  } catch (err) {
    console.error("Error marking all notifications seen:", err);
  }
}

export async function fetchUnreadCount() {
  const res = await api.get("event-notifications/unread-count/");
  return res.data.count;
}

export async function fetchAnnouncements() {
  try {
    const response = await api.get("event-notifications/announcements/");
    return response.data;
  } catch (error) {
    console.error("Error fetching announcements:", error);
    return [];
  }
}

export async function markNotificationSeen(uuid) {
  try {
    await api.patch(`event-notifications/${uuid}/seen/`, {});
  } catch (err) {
    console.error("Error marking notification seen:", err);
  }
}